if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
    __webpack_public_path__ = 'https://assets.bravenet.com/'
    window.__webpack_public_path__ = __webpack_public_path__
    let path = window.location.pathname
    if (path.charAt(path.length - 1) == '/') {
        history.replaceState({}, '', path.slice(0, -1) + window.location.search)
    }
}

import MainComponent from 'components/main-component'
import VueInitializer from 'brave-vue/root-entry'
import Vue from 'vue'
import Vuex from 'vuex'

import {MARKETING_VIEWS} from 'app-constants'
import en from 'i18n'

import routes from 'routes.json'

import home from 'views/home'
import about from 'views/about'
import login from 'views/login'
import lostpassword from 'views/lostpassword'
import register from 'views/register'
import termsOfService from 'views/terms-of-service'
import privacyPolicy from 'views/privacy-policy'
import domainsSearch from 'views/domains_search'
import sitemap from 'views/sitemap'
import serviceAdvertisement from 'views/service-advertisement'
import sitebuilder from 'views/sitebuilder/index'
import sitebuilderTemplates from 'views/sitebuilder/templates'

Vue.use(Vuex);

// so ick, can it be better somehow?
let mutations = {
    setter(state, stateObj) {
        if (typeof (stateObj) == 'object') {
            if (stateObj.property.match('.')) {
                dotset(state, stateObj.property, stateObj.value)
            } else {
                state[stateObj.property] = stateObj.value
            }
        }
    }
}

// setter for dot notation
let dotset = function (obj, dotprop, val) {

    var keys = dotprop.split('.');
    var key; // used in loop

    var currentObj = obj;

    for (var i = 0; i < keys.length - 1; i++) {

        // Get the current key we are looping
        key = keys[i];

        if (typeof currentObj[key] === 'undefined') {
            currentObj[key] = {};
        }
        currentObj = currentObj[key];
    }

    var lastKey = keys[keys.length - 1]

    // Set the property of the deepest object to the value.
    currentObj[lastKey] = val;
}

let actions = {
    setter: ({commit}, stateObj) => {
        commit('setter', stateObj)
    }
}

let store = new Vuex.Store({
    routes,
    mutations,
    actions
})

for (let key in routes) {
    let route = routes[key]
    // home is a marketing view but it's also very special
    if (route.component === 'home') {
        route.component = home
        continue
    }

    if (route.component === 'sitebuilder') {
        route.component = sitebuilder
        continue
    }
    if (route.component === 'sitebuilder/templates') {
        route.component = sitebuilderTemplates
        continue
    }

    if (route.component === 'blogs') {
        route.redirect = '/sitebuilder'
    }

    if (MARKETING_VIEWS.includes(route.component)) {
        route.props = {view: route.component}
        route.component = serviceAdvertisement
    } else {
        switch (route.component) {
            case 'about':
                route.component = about
                break
            case 'login':
                route.component = login
                break
            case 'lostpassword':
                route.component = lostpassword
                break
            case 'register':
                route.component = register
                break
            case 'terms-of-service':
                route.component = termsOfService
                break
            case 'privacy-policy':
                route.component = privacyPolicy
                break
            case 'sitemap':
                route.component = sitemap
                break
            default:
                throw new Error(`Please import and map your route to a valid Vue component in your app-entry.js. ${route.component} is an invalid route!`)
        }
    }

    routes[key] = route
}

let routing = {mode: 'history', routes}
let messages = {en}

let VueContext = VueInitializer({
    MainComponent,
    routing,
    messages
})



// WEBPACK FOOTER //
// ./apps/www.bravenet.com/src/app-entry.js